"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../../OsmosysBaseEntity");
const Integration_1 = require("../Integration");
let SalesforceSendClassification = class SalesforceSendClassification extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => Integration_1.Integration, { nullable: false }),
    typeorm_1.ManyToOne(() => Integration_1.Integration, { nullable: false }),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], SalesforceSendClassification.prototype, "integration", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: false }),
    typeorm_1.RelationId((obj) => obj.integration),
    typeorm_1.Column({ nullable: false, type: 'int' }),
    tslib_1.__metadata("design:type", Object)
], SalesforceSendClassification.prototype, "integrationId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }) // TODO: SET NULLABLE TO FALSE BEFORE PROD
    ,
    typeorm_1.Column({ nullable: false, type: 'varchar' }),
    tslib_1.__metadata("design:type", Object)
], SalesforceSendClassification.prototype, "salesforceId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }) // TODO: SET NULLABLE TO FALSE BEFORE PROD
    ,
    typeorm_1.Column({ nullable: false, type: 'varchar' }),
    tslib_1.__metadata("design:type", Object)
], SalesforceSendClassification.prototype, "salesforceObjectId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }) // TODO: SET NULLABLE TO FALSE BEFORE PROD
    ,
    typeorm_1.Column({ nullable: true, type: 'varchar' }) // TODO: SET NULLABLE TO FALSE BEFORE PROD
    ,
    tslib_1.__metadata("design:type", Object)
], SalesforceSendClassification.prototype, "name", void 0);
SalesforceSendClassification = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity(),
    typeorm_1.Unique(['integrationId', 'salesforceId'])
], SalesforceSendClassification);
exports.SalesforceSendClassification = SalesforceSendClassification;
//# sourceMappingURL=SalesforceSendClassification.js.map